/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../common";
import type {
  InflationaryCircles,
  InflationaryCirclesInterface,
} from "../InflationaryCircles";

const _abi = [
  {
    type: "constructor",
    inputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "DOMAIN_SEPARATOR",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "allowance",
    inputs: [
      {
        name: "_owner",
        type: "address",
        internalType: "address",
      },
      {
        name: "_spender",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "approve",
    inputs: [
      {
        name: "_spender",
        type: "address",
        internalType: "address",
      },
      {
        name: "_amount",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "avatar",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "balanceOf",
    inputs: [
      {
        name: "_account",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "circlesIdentifier",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "convertBatchDemurrageToInflationaryValues",
    inputs: [
      {
        name: "_demurrageValues",
        type: "uint256[]",
        internalType: "uint256[]",
      },
      {
        name: "_dayUpdated",
        type: "uint64",
        internalType: "uint64",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256[]",
        internalType: "uint256[]",
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "convertBatchInflationaryToDemurrageValues",
    inputs: [
      {
        name: "_inflationaryValues",
        type: "uint256[]",
        internalType: "uint256[]",
      },
      {
        name: "_day",
        type: "uint64",
        internalType: "uint64",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256[]",
        internalType: "uint256[]",
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "convertDemurrageToInflationaryValue",
    inputs: [
      {
        name: "_demurrageValue",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "_dayUpdated",
        type: "uint64",
        internalType: "uint64",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "convertInflationaryToDemurrageValue",
    inputs: [
      {
        name: "_inflationaryValue",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "_day",
        type: "uint64",
        internalType: "uint64",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "day",
    inputs: [
      {
        name: "_timestamp",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint64",
        internalType: "uint64",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "decimals",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint8",
        internalType: "uint8",
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "decreaseAllowance",
    inputs: [
      {
        name: "_spender",
        type: "address",
        internalType: "address",
      },
      {
        name: "_subtractedValue",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "eip712Domain",
    inputs: [],
    outputs: [
      {
        name: "fields",
        type: "bytes1",
        internalType: "bytes1",
      },
      {
        name: "name",
        type: "string",
        internalType: "string",
      },
      {
        name: "version",
        type: "string",
        internalType: "string",
      },
      {
        name: "chainId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "verifyingContract",
        type: "address",
        internalType: "address",
      },
      {
        name: "salt",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "extensions",
        type: "uint256[]",
        internalType: "uint256[]",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "hub",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract IHubV2",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "increaseAllowance",
    inputs: [
      {
        name: "_spender",
        type: "address",
        internalType: "address",
      },
      {
        name: "_addedValue",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "inflationDayZero",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "name",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "string",
        internalType: "string",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "nameRegistry",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract INameRegistry",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "nonces",
    inputs: [
      {
        name: "_owner",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "onERC1155BatchReceived",
    inputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
      {
        name: "",
        type: "address",
        internalType: "address",
      },
      {
        name: "",
        type: "uint256[]",
        internalType: "uint256[]",
      },
      {
        name: "",
        type: "uint256[]",
        internalType: "uint256[]",
      },
      {
        name: "",
        type: "bytes",
        internalType: "bytes",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bytes4",
        internalType: "bytes4",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "onERC1155Received",
    inputs: [
      {
        name: "",
        type: "address",
        internalType: "address",
      },
      {
        name: "_from",
        type: "address",
        internalType: "address",
      },
      {
        name: "_id",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "_amount",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "",
        type: "bytes",
        internalType: "bytes",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bytes4",
        internalType: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "permit",
    inputs: [
      {
        name: "_owner",
        type: "address",
        internalType: "address",
      },
      {
        name: "_spender",
        type: "address",
        internalType: "address",
      },
      {
        name: "_value",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "_deadline",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "_v",
        type: "uint8",
        internalType: "uint8",
      },
      {
        name: "_r",
        type: "bytes32",
        internalType: "bytes32",
      },
      {
        name: "_s",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setup",
    inputs: [
      {
        name: "_hub",
        type: "address",
        internalType: "address",
      },
      {
        name: "_nameRegistry",
        type: "address",
        internalType: "address",
      },
      {
        name: "_avatar",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "supportsInterface",
    inputs: [
      {
        name: "interfaceId",
        type: "bytes4",
        internalType: "bytes4",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "symbol",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "string",
        internalType: "string",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "toTokenId",
    inputs: [
      {
        name: "_avatar",
        type: "address",
        internalType: "address",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "pure",
  },
  {
    type: "function",
    name: "totalSupply",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "transfer",
    inputs: [
      {
        name: "_to",
        type: "address",
        internalType: "address",
      },
      {
        name: "_amount",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "transferFrom",
    inputs: [
      {
        name: "_from",
        type: "address",
        internalType: "address",
      },
      {
        name: "_to",
        type: "address",
        internalType: "address",
      },
      {
        name: "_amount",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "bool",
        internalType: "bool",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "unwrap",
    inputs: [
      {
        name: "_amount",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "event",
    name: "Approval",
    inputs: [
      {
        name: "owner",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "spender",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "value",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "DepositInflationary",
    inputs: [
      {
        name: "account",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "amount",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "demurragedAmount",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "EIP712DomainChanged",
    inputs: [],
    anonymous: false,
  },
  {
    type: "event",
    name: "Transfer",
    inputs: [
      {
        name: "from",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "to",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "value",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "WithdrawInflationary",
    inputs: [
      {
        name: "account",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "amount",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
      {
        name: "demurragedAmount",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "error",
    name: "CirclesAddressCannotBeZero",
    inputs: [
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesAmountMustNotBeZero",
    inputs: [
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesAmountOverflow",
    inputs: [
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesArrayMustNotBeEmpty",
    inputs: [
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesArraysLengthMismatch",
    inputs: [
      {
        name: "lengthArray1",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "lengthArray2",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesAvatarMustBeRegistered",
    inputs: [
      {
        name: "avatar",
        type: "address",
        internalType: "address",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesDemurrageAmountExceedsMaxUint190",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address",
      },
      {
        name: "circlesId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesDemurrageDayBeforeLastUpdatedDay",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address",
      },
      {
        name: "circlesId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "day",
        type: "uint64",
        internalType: "uint64",
      },
      {
        name: "lastUpdatedDay",
        type: "uint64",
        internalType: "uint64",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesERC1155CannotReceiveBatch",
    inputs: [
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesERC1155MintBlocked",
    inputs: [
      {
        name: "human",
        type: "address",
        internalType: "address",
      },
      {
        name: "mintV1Status",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesIdMustBeDerivedFromAddress",
    inputs: [
      {
        name: "providedId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesInvalidCirclesId",
    inputs: [
      {
        name: "id",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesInvalidFunctionCaller",
    inputs: [
      {
        name: "caller",
        type: "address",
        internalType: "address",
      },
      {
        name: "expectedCaller",
        type: "address",
        internalType: "address",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesInvalidParameter",
    inputs: [
      {
        name: "parameter",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesInvalidString",
    inputs: [
      {
        name: "str",
        type: "string",
        internalType: "string",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesLogicAssertion",
    inputs: [
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesProxyAlreadyInitialized",
    inputs: [],
  },
  {
    type: "error",
    name: "CirclesReentrancyGuard",
    inputs: [
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "ECDSAInvalidSignature",
    inputs: [],
  },
  {
    type: "error",
    name: "ECDSAInvalidSignatureLength",
    inputs: [
      {
        name: "length",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "ECDSAInvalidSignatureS",
    inputs: [
      {
        name: "s",
        type: "bytes32",
        internalType: "bytes32",
      },
    ],
  },
  {
    type: "error",
    name: "ERC20InsufficientAllowance",
    inputs: [
      {
        name: "spender",
        type: "address",
        internalType: "address",
      },
      {
        name: "allowance",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "needed",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "ERC20InsufficientBalance",
    inputs: [
      {
        name: "sender",
        type: "address",
        internalType: "address",
      },
      {
        name: "balance",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "needed",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "ERC20InvalidApprover",
    inputs: [
      {
        name: "approver",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "ERC20InvalidReceiver",
    inputs: [
      {
        name: "receiver",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "ERC20InvalidSender",
    inputs: [
      {
        name: "sender",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "ERC20InvalidSpender",
    inputs: [
      {
        name: "spender",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "ERC2612ExpiredSignature",
    inputs: [
      {
        name: "deadline",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "ERC2612InvalidSigner",
    inputs: [
      {
        name: "signer",
        type: "address",
        internalType: "address",
      },
      {
        name: "owner",
        type: "address",
        internalType: "address",
      },
    ],
  },
  {
    type: "error",
    name: "InvalidAccountNonce",
    inputs: [
      {
        name: "account",
        type: "address",
        internalType: "address",
      },
      {
        name: "currentNonce",
        type: "uint256",
        internalType: "uint256",
      },
    ],
  },
  {
    type: "error",
    name: "InvalidShortString",
    inputs: [],
  },
  {
    type: "error",
    name: "StringTooLong",
    inputs: [
      {
        name: "str",
        type: "string",
        internalType: "string",
      },
    ],
  },
] as const;

const _bytecode =
  "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";

type InflationaryCirclesConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: InflationaryCirclesConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class InflationaryCircles__factory extends ContractFactory {
  constructor(...args: InflationaryCirclesConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      InflationaryCircles & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(
    runner: ContractRunner | null
  ): InflationaryCircles__factory {
    return super.connect(runner) as InflationaryCircles__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): InflationaryCirclesInterface {
    return new Interface(_abi) as InflationaryCirclesInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): InflationaryCircles {
    return new Contract(
      address,
      _abi,
      runner
    ) as unknown as InflationaryCircles;
  }
}
